/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcription_MinutesInputs */



/**
* | output |
* | --- |
* | "Transcription Minutes" |
*
* @param {Transcription_MinutesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_minutes = /** @type {((inputs?: Transcription_MinutesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_MinutesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Minutes de transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Protokoll")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verbali di trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Транскрипция минут")
	if (locale === "es") return /** @type {LocalizedString} */ ("Minutos de transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转录会议记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("転写議事録")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलेखन कार्यवृत्त")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ata de transcrição")
	return /** @type {LocalizedString} */ ("Transcription Minutes")
});